import { Component, OnInit } from '@angular/core';
import { AuthenticationService, DataService } from '../../_services/index';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
    public authorizedRoles = {
        'new-user': ['admin', 'super_admin'],
        'home': ['admin', 'super_admin', 'user'],
        'redeem': ['user', 'admin_ops', 'content_admin', 'operations', 'customer_service', 'IT'],
    };
    user: any;
    menuEnableDisableToggle: boolean;
    menuToggleEnableDisable: string = "collapse navbar-collapse text-center justify-content-end"
    showHeadTitile: string = "col-md-6";
    menuGrid: string = "col-md-3";
    homeLink: string = '';

    constructor(private _authenticationService: AuthenticationService, private dataService: DataService) {
    }

    ngOnInit() {
        this.homeLink = this._authenticationService.isLoggedIn() ? '/home' : '/landing-page';
        this.menuEnableDisableToggle = true;
        this.isLoggedIn();
        this.role();
        this.user = this._authenticationService.getUserInfo();
        //console.log(this.user);
        // this.afterLoginHeadee(this.user);
        this.dataService.homeLinkObservable.subscribe((val) => {
            this.homeLink = this._authenticationService.isLoggedIn() ? '/home' : '/landing-page';
        });
    }

    isLoggedIn(): boolean {

        return this._authenticationService.isLoggedIn();

    }


    role(): string {
        return this._authenticationService.getRole();
    }

    userName(): string {
        const userName = this._authenticationService.getUserInfo();
        return userName['first_name'];
    }


    checkAuthorization(key): boolean {
        if (this.isLoggedIn()) {
            if (!key && (this.role() === 'admin' || this.role() === 'super_admin')) {
                return true;
            }
            if (this.authorizedRoles[key].indexOf(this.role()) > -1) {
                return true;
            }
            return false;
        } else {
            return false;
        }
    }

    menuToggle() {
        this.menuEnableDisableToggle = this.menuEnableDisableToggle == true ? false : true;
        if (this.menuEnableDisableToggle) {
            this.menuToggleEnableDisable = "collapse navbar-collapse text-center justify-content-end";
        } else {
            this.menuToggleEnableDisable = "navbar-collapse text-center justify-content-end";
        }
    }

    fireGAEventUserLeft() {

        (<any>window).gtag('event', 'Click', {
            'event_category': 'Button Clicked',
            'event_label': `Logout Button`
        });
    }

    // afterLoginHeadee(userDEtail) {
    //     //console.log(userDEtail);
    //     var loginVal = this._authenticationService.isLoggedIn();
    //     console.log(loginVal);
    //     if (loginVal == true) {
    //         this.showHeadTitile = "hide_div";
    //         this.menuGrid = "col-md-6 col-md-offset-3";
    //     }

    // }
}



// WEBPACK FOOTER //
// ./public/app/common/header/header.component.ts